var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr-wrapper"},[_c('VueQrcode',{staticClass:"qrcode",attrs:{"id":"qrCodeDom","value":_vm.url,"options":{size:800}}}),_c('canvas',{attrs:{"id":"canvas"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }